<template>
    <div class="question-block pa-4 mt-4">
        <div class="headline mb-4 font-weight-bold">{{ $t("Вопрос {questionNumber} из {questionsCount}", {questionNumber: question_number+1, questionsCount: questions_length}) }}</div>
        <div class="question-text mb-4" v-html="questions[question_number].question"></div>
        <v-layout column mb-5>
            <div v-if="questions[question_number].hasImage" class="grey-text mb-3">
                {{ questions[question_number].type=='radio' ? $t("Выберите картинку с правильным ответом (возможен один вариант)") : $t("Выберите картинки с правильными ответами (возможно несколько вариантов)") }}</div>
            <QuestionTypeSwitch
                :name="questions[question_number].type"
                :question_type='questions[question_number].type'
                :question_number='question_number'
                :variants="questions[question_number].type !='text_field' ? questions[question_number].variants : []"
                @change='answer_checked($event, question_number)'
            />
        </v-layout>
        <v-layout row wrap justify-space-between>
            <buttonBdWhite :class="{'flex xs12 order-xs2 mb-4': $vuetify.breakpoint.xs}" @click.native="prev_question()" v-text="prevButtonText(questions[question_number])" />
            <buttonRed :class="{'flex xs12 mb-2': $vuetify.breakpoint.xs}"
                       @click.native="wrap_answer()"
            >{{ question_number == questions_length - 1 ? $t("Завершить тестирование") : $t("Следующий вопрос") }}</buttonRed>
            <!-- <modal v-if="question_number == questions_length-1" /> -->
        </v-layout>
    </div>
</template>

<script>
import {button_red, button_bd_white} from '@/components/ui/buttons/base_buttons.js';
import QuestionTypeSwitch from './question_type_switch';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    QuestionTypeSwitch,
    'buttonRed'    : button_red,
    'buttonBdWhite': button_bd_white,
  },
  data() {
    return {
      answer_check: {
        'question_id': '',
        'answer'     : '',
      },
      checkbox_checked: [],
    };
  },
  computed: {
    ...mapGetters('testing/questions', [
      'question_number',
      'questions',
      'stats',
      'questions_length',
      'question_answered',
      'test_history',
    ]),
    ...mapGetters('course_info', [
      'points_required_test',
    ]),
    ...mapGetters('course_info/content', [
      'course_id',
    ]),
  },
  methods: {
    ...mapMutations('testing/questions', [
      'ANSWERED',
      'NOT_ANSWERED',
      'SET_ANSWERED',
    ]),
    ...mapActions('testing/questions', [
      'prev_question',
      'next_question',
      'test_result',
      'reset_selected',
      'question_set_answered',
    ]),
    ...mapMutations('course_info/modals', [
      'CLOSE_MODAL',
      'OPEN_MODAL',
    ]),
    question_type: function(question) {
      if (question.type=='radio') {
        return 'radio';
      } else {
        return 'checkbox';
      }
    },
    async answer_checked($event, question_number) {
      let type = this.questions[question_number].type;
      let variants = this.questions[question_number].variants;
      this.answer_check.question_id = this.questions[question_number].id;
      if (type=='text_field') {
        this.answer_check.answer = $event;
        this.SET_ANSWERED({event: $event, question_number});
      } else if (type=='radio') {
        // $event.question_number = question_number;
        this.answer_check.answer = variants[$event.variant_number].id;
        // this.SET_ANSWERED({event: $event, question_number});
      } else if (type=='checkbox') {
        this.SET_ANSWERED({event: $event, question_number});

        this.checkbox_checked = [];
        this.answer_check = {};
        // let findAnswer;
        // if (this.test_history) {
        //   findAnswer = this.test_history.find((item)=>{
        //     return item.question_id == this.questions[question_number].id;
        //   });
        // }
        // if (findAnswer) {
        //   this.checkbox_checked = findAnswer.answer.split(',');
        // }

        // let variant = variants[$event.variant_number];
        // if (this.checkbox_checked.includes(variant.id)) {
        //   let foundIndex = this.checkbox_checked.findIndex((item)=>{
        //     return item == variant.id;
        //   });
        //   this.checkbox_checked.splice(foundIndex, 1);
        // } else if (variant.selected) {
        //   this.checkbox_checked.push(variant.id);
        // }
        // this.answer_check.answer = this.checkbox_checked;
      }
    },
    prevButtonText: function(question) {
      if (this.question_number==0) {
        return this.$t('Назад к урокам');
      } else {
        return this.$t('Предыдущий вопрос');
      }
    },
    wrap_answer() {
      let question_id = this.questions[this.question_number].id;
      let type = this.questions[this.question_number].type;
      let variants = this.questions[this.question_number].variants;

      if (this.answer_check.question_id && this.answer_check.answer) {
        this.next_question(this.answer_check);
      } else {
        this.answer_check.question_id = question_id;

        if (type=='checkbox') {
          variants.forEach((variant)=>{
            if (variant.selected) {
              this.checkbox_checked.push(variant.id);
            }
          });
          this.answer_check.answer = this.checkbox_checked;
        } else {
          let selected_variant = variants.find((variant)=>{
            return variant.selected;
          });
          if (selected_variant) {
            this.answer_check.answer = selected_variant.id;
          } else {
            this.answer_check.answer = '';
          }
        }
        this.next_question(this.answer_check);
      }
      this.checkbox_checked = [];
      this.answer_check = {};
    },
  },
};
</script>
